{
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  document.querySelectorAll('.fancy-overlapping-slider').forEach((block) => {
    const slider = block.querySelector('ada-slider')
    const panels = block.querySelectorAll('.fancy-overlapping-slider--panel')
    if (!slider) return

    if (prefersReduced && slider.autoplaying && typeof slider.pause === 'function') {
      slider.manualPaused = true
      slider.pause()
    }

    if (panels.length < 2) return

    const setActive = (index) => {
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', Number(panel.dataset.slide) === index)
      })
    }

    jQuery(slider).on('afterChange', (event, slick, current) => setActive(current))
    setActive(0)
  })
}
